import { render } from "./ListarAlertas.vue?vue&type=template&id=762e87cc&scoped=true"
import script from "./ListarAlertas.vue?vue&type=script&lang=js"
export * from "./ListarAlertas.vue?vue&type=script&lang=js"

import "./ListarAlertas.vue?vue&type=style&index=0&id=762e87cc&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762e87cc"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QImg,QToggle,QTd});
